<template>
  <div class="configurator-preview-block" :class="{loading: loading}" :style="dynHeight" @mouseover="animate = true" @mouseout="animate = false">
    <preview-image
      v-for="(image, index) in getImages"
      v-if="!loading"
      :key="index"
      :image="image"
      :animate="animate"
      :width="dimensions.width"
      :height="dimensions.height"
    />
    <img src="https://konfigurator.loewe-zaun.de/img/tuev_logo.png" class="logo">
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import PreviewImage from './previewImage'

export default {
  components: {
    PreviewImage
  },
  data: () => ({
    animate: false,
    dynHeight: { height: 320 + 'px' }
  }),
  computed: {
    ...mapGetters({
      images: 'configurator/previewImages',
      loading: 'configurator/previewImagesLoading',
      config: 'configurator/config'
    }),
    getImages () {
      return _.orderBy(this.images, 'order')
    },
    dimensions () {
      let values = null
      const self = this
      if (this.config) {
        const dims = self.config
        if (dims && typeof dims.width !== 'undefined') {
          if (dims.width === 0 && dims.height === 0) {
            self.dynHeight = { height: 320 + 'px' }
            values = { width: 730 + 'px', height: 320 + 'px' }
          } else {
            self.dynHeight = { height: dims.height + 'px' }
            values = { width: dims.width + 'px', height: dims.height + 'px' }
          }
        } else {
          self.dynHeight = { height: 320 + 'px' }
          values = { width: 730 + 'px', height: 320 + 'px' }
        }
      }
      return values
    }
  }
}
</script>
